module.exports = __webpack_public_path__ + "assets/img/md5.bed35480.svg";